import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBrain, faUsers, faChartLine, faCommentDots, faHeart } from "@fortawesome/free-solid-svg-icons";
import { Bar, Line, Pie, Doughnut } from "react-chartjs-2";
import 'chart.js/auto';

const StressBankHome = () => {
  const [activeTab, setActiveTab] = useState("about");

  const stressData = {
    labels: [
        "Work",
        "Family",
        "Health",
        "Friends",
        "Finance",
        "Government",
        "Society",
        "Neighbour",
        "Self",
        "Spouse",
        "Environment",
        "Others",
    ],
    datasets: [
        {
        label: "Stress Entries",
        data: [12, 9, 6, 4, 5, 2, 3, 1, 7, 6, 7, 3], // dummy data for each category
        backgroundColor: [
            "rgba(255, 99, 132, 0.7)",
            "rgba(54, 162, 235, 0.7)",
            "rgba(255, 206, 86, 0.7)",
            "rgba(75, 192, 192, 0.7)",
            "rgba(153, 102, 255, 0.7)",
            "rgba(255, 159, 64, 0.7)",
            "rgba(199, 199, 199, 0.7)",
            "rgba(83, 102, 255, 0.7)",
            "rgba(255, 99, 71, 0.7)",
            "rgba(60, 179, 113, 0.7)",
            "rgba(238, 130, 238, 0.7)",
        ],
        borderColor: "rgba(255,255,255,0.8)",
        borderWidth: 1,
        },
    ],
};

 const stressLog = [
  { desc: "Project deadline approaching", people: "Team", type: "Work", date: "2025-12-14", severity: 8 },
  { desc: "Family argument over finances", people: "Family", type: "Family", date: "2025-12-13", severity: 7 },
  { desc: "Fever and fatigue", people: "Self", type: "Health", date: "2025-12-12", severity: 6 },
  { desc: "Friend cancelled plans", people: "Friends", type: "Friends", date: "2025-12-11", severity: 4 },
  { desc: "Unexpected bills", people: "Self", type: "Finance", date: "2025-12-10", severity: 7 },
  { desc: "Policy changes affecting work", people: "Government", type: "Government", date: "2025-12-09", severity: 5 },
  { desc: "Noise from society construction", people: "Society", type: "Society", date: "2025-12-08", severity: 3 },
  { desc: "Neighbour dispute over parking", people: "Neighbour", type: "Neighbour", date: "2025-12-07", severity: 4 },
  { desc: "Self-doubt about career", people: "Self", type: "Self", date: "2025-12-06", severity: 6 },
  { desc: "Conflict with spouse", people: "Spouse", type: "Spouse", date: "2025-12-05", severity: 8 },
];

const chartOptions = (title) => ({
  responsive: true,
  plugins: {
    legend: { labels: { color: "white" } },
    title: { display: true, text: title, color: "white" },
  },
  scales: {
    x: { ticks: { color: "white" }, grid: { color: "#444" } },
    y: { ticks: { color: "white" }, grid: { color: "#444" } },
  },
});


const stressByCategoryData = {
  labels: [
    "Work", "Family", "Health", "Friends", "Finance",
    "Government", "Society", "Neighbour", "Self", "Spouse", "Environment"
  ],
  datasets: [
    {
      label: "Stress Entries",
      data: [12, 9, 7, 5, 8, 4, 3, 4, 6, 5, 2],
      backgroundColor: "rgba(236, 72, 153, 0.7)", // pink
    },
  ],
};


const avgSeverityData = {
  labels: ["Work", "Family", "Health", "Finance", "Self", "Spouse"],
  datasets: [
    {
      label: "Average Severity",
      data: [7.8, 6.9, 6.1, 7.5, 6.7, 8.0],
      backgroundColor: "rgba(168, 85, 247, 0.7)", // purple
    },
  ],
};

const moodDistributionData = {
  labels: ["😰 Anxious", "😢 Sad", "😐 Neutral", "🙂 Calm", "😓 Stressed"],
  datasets: [
    {
      label: "Mood Count",
      data: [14, 8, 10, 6, 12],
      backgroundColor: [
        "#f43f5e", // red
        "#60a5fa", // blue
        "#9ca3af", // gray
        "#34d399", // green
        "#f97316", // orange
      ],
    },
  ],
};

const stressOverTimeData = {
  labels: ["Week 1", "Week 2", "Week 3", "Week 4"],
  datasets: [
    {
      label: "Stress Entries",
      data: [18, 22, 30, 26],
      borderColor: "#ec4899",
      backgroundColor: "rgba(236, 72, 153, 0.3)",
      tension: 0.4,
      fill: true,
    },
  ],
};

const triggerData = {
  labels: [
    "Deadlines", "Finance", "Family Conflict",
    "Health Issues", "Social Pressure", "Environment"
  ],
  datasets: [
    {
      label: "Trigger Frequency",
      data: [15, 11, 9, 7, 6, 4],
      backgroundColor: "rgba(59, 130, 246, 0.7)", // blue
    },
  ],
};

const followUpData = {
  labels: ["Follow-up Needed", "No Follow-up"],
  datasets: [
    {
      label: "Entries",
      data: [14, 36],
      backgroundColor: ["#facc15", "#22c55e"], // yellow / green
    },
  ],
};

const locationStressData = {
  labels: ["Home", "Office", "Public", "Travel"],
  datasets: [
    {
      label: "Stress Count",
      data: [18, 20, 7, 5],
      backgroundColor: "rgba(14, 165, 233, 0.7)",
    },
  ],
};


  return (
    <div className="flex flex-col min-h-screen bg-black text-white font-sans">
      {/* Header */}
      <header className="bg-gray-900 p-4 shadow-md">
        <div className="mx-auto flex flex-col justify-center items-center">
            <h1 className="text-xl lg:text-2xl font-bold text-yellow-200 text-left">😰 StressBank</h1>
            <p className="text-gray-300 mt-1 text-xs lg:text-sm justify-center">Track your stress. Gain insights. Improve your mental well-being.</p>
        </div>
      </header>

      {/* Tabs */}
      <nav className="bg-gray-800 p-4">
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-2 place-items-center">
            {[
                { key: "about", label: "About StressBank", emoji: "🧠" },         
                { key: "log", label: "Log Stress", emoji: "📝" },                
                { key: "stresslog", label: "Stress Log", emoji: "📒" },         
                { key: "analytics", label: "Analytics", emoji: "📊" },          
                { key: "aicounselling", label: "AI Counselling", emoji: "🤖" }, 
                { key: "consulting", label: "Consulting", emoji: "💬" },      
            ].map((tab) => (
            <button
                key={tab.key}
                onClick={() => setActiveTab(tab.key)}
                className={`text-xs lg:text-sm px-4 py-2 rounded-md border transition-colors duration-300
                ${activeTab === tab.key ? "bg-pink-500 border-pink-500" : "bg-gray-700 border-gray-600 hover:bg-pink-500 hover:border-pink-500"}
                `}
            >
                <span className="mr-2">{tab.emoji}</span>
                {tab.label}
            </button>
            ))}
        </div>
        </nav>

      {/* Main Content */}
      <main className="flex-grow p-6">
        {activeTab === "about" && (
            <div className="flex flex-col items-center text-center gap-4 max-w-4xl mx-auto">
                <FontAwesomeIcon icon={faBrain} size="3x" className="text-pink-500" />

                <p className="text-gray-200 text-xs lg:text-sm">
                    StressBank is your personal stress tracker and AI counselling companion. Log your stress, identify
                    triggers, and get actionable insights to improve your mental well-being.
                </p>

                {/* Extended Insights */}
                <div className="text-left text-gray-300 text-sm lg:text-base space-y-4 mt-4">
                    <p className=" text-xs lg:text-sm">
                        <span className="text-yellow-200 font-semibold">What is Stress?</span><br />
                        Stress is the body and mind’s response to pressure, uncertainty, or perceived threats. While short-term
                        stress can improve focus and performance, prolonged or unmanaged stress can harm mental, emotional,
                        and physical health.
                    </p>

                    <p className=" text-xs lg:text-sm">
                        <span className="text-yellow-200 font-semibold">How does stress impact humans?</span><br />
                        Chronic stress affects sleep, decision-making, relationships, productivity, and immunity. It often
                        manifests as anxiety, fatigue, irritability, burnout, or loss of motivation, gradually reducing
                        quality of life.
                    </p>

                    <p className=" text-xs lg:text-sm">
                        <span className="text-yellow-200 font-semibold">Stress in India</span><br />
                        In India, stress is amplified by work pressure, financial insecurity, academic competition,
                        urban living conditions, social expectations, and limited access to mental health support.
                        Many cases go unreported due to stigma or lack of awareness.
                    </p>

                    <p className=" text-xs lg:text-sm">
                        <span className="text-yellow-200 font-semibold">Stress at a global level</span><br />
                        Globally, stress is rising due to economic uncertainty, rapid technological change,
                        work-life imbalance, climate concerns, and social isolation. The World Health Organization
                        recognizes stress-related disorders as a growing public health challenge.
                    </p>

                    <p className=" text-xs lg:text-sm">
                        <span className="text-yellow-200 font-semibold">Health hazards caused by stress</span><br />
                        Unmanaged stress is linked to heart disease, high blood pressure, diabetes, depression,
                        anxiety disorders, substance abuse, weakened immunity, and burnout-related conditions.
                    </p>

                    <p className=" text-xs lg:text-sm">
                        <span className="text-yellow-200 font-semibold">Stress as a social issue</span><br />
                        Stress does not affect individuals alone. It impacts families, workplaces, communities,
                        and economies. Rising stress contributes to workplace attrition, domestic conflicts,
                        reduced productivity, and social disengagement.
                    </p>

                    <p className=" text-xs lg:text-sm">
                        <span className="text-yellow-200 font-semibold">Why stress must be handled</span><br />
                        Early identification and management of stress prevents long-term damage.
                        Addressing stress improves personal well-being, social harmony, workplace health,
                        and overall societal resilience.
                    </p>

                    <p className=" text-xs lg:text-sm">
                        <span className="text-yellow-200 font-semibold">Who should handle stress?</span><br />
                        Stress management is a shared responsibility. Individuals, families, employers,
                        healthcare professionals, NGOs, educational institutions, and policymakers
                        all play a role in creating supportive environments.
                    </p>

                    <p className=" text-xs lg:text-sm">
                        <span className="text-yellow-200 font-semibold">Role of data & StressBank</span><br />
                        StressBank transforms stress from an invisible feeling into measurable data.
                        By logging patterns, severity, triggers, and emotions, it enables individuals,
                        counsellors, NGOs, and systems to move from reactive support to proactive,
                        evidence-based stress management.
                    </p>
                </div>
            </div>
        )}

        {activeTab === "log" && (
            <div className="flex flex-col items-center justify-center gap-6 w-full px-4 py-6">
                <h2 className="text-lg lg:text-2xl font-semibold text-center text-white">Log Your Stress</h2>

                <form className="flex flex-col gap-4 w-full max-w-2xl bg-gray-900 p-6 rounded-xl shadow-md border border-gray-700">
                
                {/* Description */}
                <input
                    type="text"
                    placeholder="Brief description of stress..."
                    className="p-3 w-full rounded-md bg-gray-800 text-white border border-gray-700 focus:outline-none focus:ring-2 focus:ring-pink-500"
                    style={{width: "100%"}}
                />

                {/* People concerned */}
                <input
                    type="text"
                    placeholder="People concerned (optional)"
                    className="p-3 w-full rounded-md bg-gray-800 text-white border border-gray-700 focus:outline-none focus:ring-2 focus:ring-pink-500"
                    style={{width: "100%"}}                
                />

                {/* Stress type */}
                <select className="p-1 h-10 w-full rounded-md bg-gray-800 text-white border border-gray-700 focus:outline-none focus:ring-2 focus:ring-pink-500">
                    <option value="">Select Stress Type</option>
                    <option value="work">Work</option>
                    <option value="family">Family</option>
                    <option value="health">Health</option>
                    <option value="friends">Friends</option>
                    <option value="finance">Finance</option>
                    <option value="government">Government</option>
                    <option value="society">Society</option>
                    <option value="neighbour">Neighbour</option>
                    <option value="self">Self</option>
                    <option value="spouse">Spouse</option>
                    <option value="environment">Environment</option>
                    <option value="others">Others</option>
                </select>

                {/* Severity */}
                <div className="flex flex-col">
                    <label className="text-gray-300 mb-1">Severity (1–10)</label>
                    <input
                    type="range"
                    min="1"
                    max="10"
                    defaultValue="5"
                    className="w-full accent-pink-500"
                    />
                </div>

                {/* Mood / Emotion */}
                <select className="p-1 h-10 w-full rounded-md bg-gray-800 text-white border border-gray-700 focus:outline-none focus:ring-2 focus:ring-pink-500">
                    <option value="">Select Mood / Emotion</option>
                    <option value="anxious">😰 Anxious</option>
                    <option value="sad">😢 Sad</option>
                    <option value="neutral">😐 Neutral</option>
                    <option value="happy">🙂 Happy</option>
                    <option value="stressed">😓 Stressed</option>
                </select>

                {/* Trigger(s) */}
                <p className="text-gray-400">Select Trigger Reasons:</p>
                <select multiple className="p-3 h-40 w-full rounded-md bg-gray-800 text-white border border-gray-700 focus:outline-none focus:ring-2 focus:ring-pink-500">
                    <option value="deadlines">Deadlines</option>
                    <option value="family">Family</option>
                    <option value="finance">Finance</option>
                    <option value="health">Health</option>
                    <option value="social">Social</option>
                    <option value="environment">Environment</option>
                    <option value="other">Other</option>
                </select>

                {/* Coping strategy */}
                <p className="text-gray-400">Coping strategy used (optional):</p>
                <input
                    type="text"
                    placeholder="Coping strategy used (optional)"
                    className="p-3 w-full rounded-md bg-gray-800 text-white border border-gray-700 focus:outline-none focus:ring-2 focus:ring-pink-500"
                    style={{width: "100%"}}               
               />

                {/* Date & Time */}
                <p className="text-gray-400">Date Time (optional):</p>
                <input
                    type="datetime-local"
                    className="p-3 w-full rounded-md bg-gray-800 text-white border border-gray-700 focus:outline-none focus:ring-2 focus:ring-pink-500"
                />

                {/* Location */}
                <input
                    type="text"
                    placeholder="Location (optional)"
                    className="p-3 w-full rounded-md bg-gray-800 text-white border border-gray-700 focus:outline-none focus:ring-2 focus:ring-pink-500"
                    style={{width: "100%"}}                
                />

                {/* Attachments */}
                <input
                    type="file"
                    className="p-2 w-full text-gray-200 bg-gray-800 border border-gray-700 rounded-md"
                />

                {/* Follow-up reminder */}
                <div className="flex items-center gap-2">
                    <input type="checkbox" id="followup" className="accent-pink-500" />
                    <label htmlFor="followup" className="text-gray-300">Set follow-up reminder</label>
                </div>

                {/* Submit button */}
                <button
                    type="submit"
                    className="flex items-center justify-center w-32 lg:w-40 mx-auto text-sm gap-2 bg-pink-500 hover:opacity-90 p-3 rounded-md font-semibold"
                >
                    <FontAwesomeIcon icon={faCommentDots} /> Log Stress
                </button>
                </form>
            </div>
        )}

        {activeTab === "stresslog" && (
            <div className="flex flex-col items-center gap-6 w-full px-4 py-6">
                <h2 className="text-lg lg:text-2xl font-semibold text-center text-white">
                     My Stress Log
                </h2>

                <div className="w-full max-w-5xl grid grid-cols-1 md:grid-cols-2 gap-4">
                {stressLog.map((entry, idx) => (
                    <div
                    key={idx}
                    className="bg-gray-800 p-4 rounded-xl border border-gray-700 flex flex-col gap-3 hover:bg-gray-700 transition-colors"
                    >
                    {/* Header */}
                    <div className="flex justify-between items-center">
                        <span className="font-semibold text-pink-500">
                        {entry.type}
                        </span>
                        <span className="text-gray-400 text-xs">
                        {entry.datetime || entry.date}
                        </span>
                    </div>

                    {/* Description */}
                    <p className="text-gray-200 text-sm">
                        {entry.desc}
                    </p>

                    {/* Meta info */}
                    <div className="text-xs text-gray-400 space-y-1">
                        <p><span className="text-gray-300">People:</span> {entry.people || "—"}</p>
                        <p><span className="text-gray-300">Location:</span> {entry.location || "—"}</p>
                        <p><span className="text-gray-300">Mood:</span> {entry.mood || "—"}</p>
                    </div>

                    {/* Triggers */}
                    {entry.triggers?.length > 0 && (
                        <div className="flex flex-wrap gap-1 mt-1">
                        {entry.triggers.map((trigger, i) => (
                            <span
                            key={i}
                            className="text-xs px-2 py-0.5 rounded-full bg-gray-700 text-gray-200"
                            >
                            {trigger}
                            </span>
                        ))}
                        </div>
                    )}

                    {/* Severity */}
                    <div className="flex items-center gap-2 mt-2">
                        <span className="text-xs text-gray-300">Severity</span>
                        <div className="flex gap-1">
                        {Array.from({ length: 10 }).map((_, i) => (
                            <span
                            key={i}
                            className={`h-2 w-2 rounded-full ${
                                i < entry.severity ? "bg-pink-500" : "bg-gray-600"
                            }`}
                            />
                        ))}
                        </div>
                    </div>

                    {/* Coping Strategy */}
                    {entry.coping && (
                        <p className="text-xs text-gray-400 mt-1">
                        <span className="text-gray-300">Coping:</span> {entry.coping}
                        </p>
                    )}

                    {/* Attachments & Follow-up */}
                    <div className="flex justify-between items-center text-xs text-gray-400 mt-1">
                        <span>
                        📎 Attachment: {entry.attachment ? "Yes" : "No"}
                        </span>
                        {entry.followUp && (
                        <span className="text-yellow-400">⏰ Follow-up set</span>
                        )}
                    </div>

                    {/* Action */}
                    <button className="mt-3 bg-purple-600 hover:opacity-90 text-white text-xs py-2 rounded-md font-medium">
                        Start AI Counselling
                    </button>
                    </div>
                ))}
                </div>
            </div>
        )}

        {activeTab === "analytics" && (
            <div className="flex flex-col items-center gap-8 w-full px-4 py-6">
                <h2 className="text-lg lg:text-2xl font-semibold text-center text-white">
                    Stress Analytics & Insights
                </h2>

                <div className="w-full max-w-6xl grid grid-cols-1 lg:grid-cols-2 gap-6">

                    {/* Stress by Category */}
                    <div className="bg-gray-800 p-4 rounded-xl border border-gray-700">
                        <Bar data={stressByCategoryData} options={chartOptions("Stress by Category")} />
                    </div>

                    {/* Average Severity */}
                    <div className="bg-gray-800 p-4 rounded-xl border border-gray-700">
                        <Bar data={avgSeverityData} options={chartOptions("Average Severity by Type")} />
                    </div>

                    {/* Mood Distribution */}
                    <div className="bg-gray-800 p-4 rounded-xl border border-gray-700">
                        <Pie data={moodDistributionData} options={chartOptions("Mood Distribution")} />
                    </div>

                    {/* Stress by Time */}
                    <div className="bg-gray-800 p-4 rounded-xl border border-gray-700">
                        <Line data={stressOverTimeData} options={chartOptions("Stress Over Time")} />
                    </div>

                    {/* Location Stress by Time */}
                    <div className="bg-gray-800 p-4 rounded-xl border border-gray-700">
                        <Bar data={locationStressData} options={chartOptions("Location Stress")} />
                    </div>

                    {/* Triggers */}
                    <div className="bg-gray-800 p-4 rounded-xl border border-gray-700">
                        <Bar data={triggerData} options={chartOptions("Top Stress Triggers")} />
                    </div>

                    {/* Follow-ups */}
                    <div className="bg-gray-800 p-4 rounded-xl border border-gray-700">
                        <Doughnut data={followUpData} options={chartOptions("Follow-up Required")} />
                    </div>
                </div>

                {/* Insight Summary */}
                <div className="bg-gray-900 p-4 rounded-xl border border-gray-700 max-w-4xl text-sm text-gray-300">
                <p>📊 <b>Key Insight:</b> Work and Finance stress show the highest average severity.</p>
                <p>🧠 Mood patterns indicate anxiety peaks during late evenings.</p>
                <p>🚨 22% of entries may benefit from immediate counselling intervention.</p>
                </div>
            </div>
            )}


        {activeTab === "aicounselling" && (
          <div className="flex flex-col items-center gap-4 text-center">
            <h2 className="text-lg lg:text-xl font-semibold">AI Counselling</h2>
            <p className="text-gray-200">Check With AI (Disclaimer: This is purely for informative purpose. Please consult you human counsellor for actual analaysis and remdy!).</p>
            <button className="flex justify-center items-center gap-2 text-xs w-40 lg:text-sm lg:w-48 bg-purple-600 hover:opacity-90 p-3 rounded-md font-semibold">
              <FontAwesomeIcon icon={faUsers} /> Start AI Counselling
            </button>
          </div>
        )}

        {activeTab === "consulting" && (
          <div className="flex flex-col items-center gap-4 text-center">
            <h2 className="text-lg lg:text-xl font-semibold">Consultants</h2>
            <p className="text-gray-200">
                 Connect with counsellors, doctors, or NGOs for personalized guidance based on your stress entries.
            </p>
            <button className="flex justify-center items-center gap-2 bg-purple-600 hover:opacity-90 p-3 rounded-md font-semibold">
              <FontAwesomeIcon icon={faUsers} /> View Consultant
            </button>
          </div>
        )}
      </main>

      {/* Footer */}
      <footer className="bg-gray-900 p-4 text-center text-gray-400">
        <p className=" text-xs lg:text-sm">
          &copy; {new Date().getFullYear()} Think5Whys | Made with <FontAwesomeIcon icon={faHeart} className="text-red-500" /> for mental wellness
        </p>
      </footer>
    </div>
  );
};

export default StressBankHome;
